import { Phone, MessageCircle, MapPin, Mail, Clock, ArrowUpRight } from "lucide-react";
import { SITE, WA_DEFAULT } from "@/lib/site";

export default function Footer({ onBook }) {
  return (
    <footer id="contact" data-testid="footer-section" className="border-t border-white/10 bg-[#0F1418]">
      <div className="mx-auto max-w-7xl px-4 py-20 sm:px-8 lg:px-16">
        <div className="grid gap-12 lg:grid-cols-2">
          <div>
            <p className="text-xs font-medium uppercase tracking-[0.3em] text-[#D4AF37]">Start your journey</p>
            <h2 className="mt-4 font-serif text-3xl font-semibold tracking-tight sm:text-5xl">
              The road is waiting.<br />
              <span className="italic text-[#D4AF37]">So is your car.</span>
            </h2>
            <div className="mt-8 flex flex-wrap gap-4">
              <button
                onClick={onBook}
                data-testid="footer-book-btn"
                className="flex items-center gap-2 rounded-full bg-[#D4AF37] px-6 py-3 text-sm font-semibold text-[#0F1418] transition-transform hover:scale-105"
              >
                <MessageCircle className="h-4 w-4" /> Book Your Trip
              </button>
              <a
                href={SITE.phoneHref}
                data-testid="footer-call-link"
                className="flex items-center gap-2 rounded-full border border-white/20 px-6 py-3 text-sm font-medium text-white/85 transition-colors hover:border-[#D4AF37] hover:text-[#D4AF37]"
              >
                <Phone className="h-4 w-4" /> {SITE.phoneDisplay}
              </a>
            </div>
          </div>
          <div className="grid gap-8 sm:grid-cols-2">
            <div>
              <h3 className="text-xs font-medium uppercase tracking-[0.3em] text-white/40">Explore</h3>
              <ul className="mt-4 space-y-2.5 text-sm text-white/65">
                <li><a href="#services" className="transition-colors hover:text-[#D4AF37]">Services</a></li>
                <li><a href="#packages" className="transition-colors hover:text-[#D4AF37]">Tour packages</a></li>
                <li><a href="#fleet" className="transition-colors hover:text-[#D4AF37]">Our fleet</a></li>
                <li><a href="#estimator" className="transition-colors hover:text-[#D4AF37]">Fare estimator</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-xs font-medium uppercase tracking-[0.3em] text-white/40">Reach us</h3>
              <ul className="mt-4 space-y-2.5 text-sm text-white/65">
                <li className="flex items-start gap-2">
                  <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#D4AF37]" />
                  <span>New Colony, 1st Lane, near V-Bazar,<br />Rayagada, Odisha 765001</span>
                </li>
                <li>
                  <a href={SITE.phoneHref} className="flex items-center gap-2 transition-colors hover:text-[#D4AF37]">
                    <Phone className="h-4 w-4 text-[#D4AF37]" /> {SITE.phoneDisplay}
                  </a>
                </li>
                <li>
                  <a href={`mailto:${SITE.email}`} data-testid="footer-email-link" className="flex items-center gap-2 transition-colors hover:text-[#D4AF37]">
                    <Mail className="h-4 w-4 text-[#D4AF37]" /> {SITE.email}
                  </a>
                </li>
                <li className="flex items-center gap-2">
                  <Clock className="h-4 w-4 text-[#D4AF37]" /> Opens 7:00 AM, every day
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center">
          <p className="text-xs text-white/40">© {new Date().getFullYear()} {SITE.name}. All rights reserved.</p>
          <a
            href={SITE.domain}
            data-testid="footer-domain-link"
            className="flex items-center gap-1 text-xs text-white/40 transition-colors hover:text-[#D4AF37]"
          >
            jayjagannathtravels.in <ArrowUpRight className="h-3 w-3" />
          </a>
        </div>
      </div>
    </footer>
  );
}
